import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllProjects } from "../service/apiUrl";
import { API } from "../service/Interceptor";
import { enrichJobBriefs } from "utils/enrichJobBrief";

const initialState = {
  projects: [],
  project: null,
  totalProjects: 0,
  isLoading: false,
  hasError: false,
  // lastFilters: {},
};

export const getProjects = createAsyncThunk(
  "get-all-projects",
  async (params, thunkAPI) => {
    try {
      const res = await API.get(getAllProjects, { params });
      const data = res.data.data || {};
      const results = await enrichJobBriefs(data.results || []);
      return {
        ...data,
        results,
        pageNo: params.pageNo,
      };
    } catch (error) {
      console.error("Error fetching projects:", error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAppliedProjects = createAsyncThunk(
  "get-my-applications",
  async () => {
    try {
      const res = await API.get("api/job-applications");
      return res?.data?.data?.results;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getProjectbyID = createAsyncThunk(
  "get-project-by-id",
  async (arg) => {
    const id = typeof arg === "object" && arg != null ? arg.id ?? arg.jobId : arg;
    const skipErrorToast =
      typeof arg === "object" && arg != null && !!arg.skipErrorToast;
    try {
      const res = await API.get(`api/jobs/${id}`, { skipErrorToast });
      return res?.data?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getApplicationbyID = createAsyncThunk(
  "get-application-by-id",
  async (id) => {
    try {
      const res = await API.get(`api/job-applications/${id}`);
      // console.log(res.data.data.jobResponseDto);
      return res?.data?.data?.jobResponseDto;
    } catch (error) {
      console.log(error);
    }
  }
);

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ------------------GET ALL PROJECTS------------------
      .addCase(getProjects.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })

      .addCase(getProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;

        // const { pageNo, results, totalRecord, ...filters } = action.payload;
        const { pageNo, results, totalRecord } = action.payload || {};
        const list = Array.isArray(results) ? results : [];

        if (pageNo === 1) {
          state.projects = [...list];
        } else {
          state.projects = [...(state.projects || []), ...list];
        }

        state.totalProjects = totalRecord;
        // state.lastFilters = filters;
      })

      // ------------------GET PROJECT BY ID------------------
      .addCase(getProjectbyID.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getProjectbyID.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getProjectbyID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.project = action.payload;
      })

      // ------------------GET APPLICATION BY ID------------------
      .addCase(getApplicationbyID.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getApplicationbyID.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getApplicationbyID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.project = action.payload;
      })

      // ------------------GET MY APPLICATIONS------------------
      .addCase(getAppliedProjects.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getAppliedProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      .addCase(getAppliedProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.projects = action.payload;
      });
  },
});

export default projectsSlice.reducer;
